import { render, staticRenderFns } from "./Fideicomiso.vue?vue&type=template&id=f29aa196&scoped=true"
import script from "./Fideicomiso.vue?vue&type=script&lang=js"
export * from "./Fideicomiso.vue?vue&type=script&lang=js"
import style0 from "./Fideicomiso.vue?vue&type=style&index=0&id=f29aa196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29aa196",
  null
  
)

export default component.exports